import { render, staticRenderFns } from "./ThemeSettings.vue?vue&type=template&id=27d1f674&"
import script from "./ThemeSettings.vue?vue&type=script&lang=js&"
export * from "./ThemeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports